module.exports = __webpack_public_path__ + "img/bg14.847b5677.png";